// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"9a1b3123","159":"0b09a655"}[chunkId] + ".chunk.js";
};